import {isAfter, startOfDay, startOfToday} from 'date-fns';
import {z} from 'zod';

import {PaymentTypeSchema} from '@dms/api/shared';
import i18n from '@dms/i18n';

// The picker blocks future days via maxDate, but a manually typed date can bypass it.
const isDateNotInFuture = (date: Date) => !isAfter(startOfDay(date), startOfToday());

const PastOrTodayDateSchema = z
  .date()
  .refine(isDateNotInFuture, {message: i18n.t('errors.date_cannot_be_in_future')});

export const ReceiveNoteCorrectionFormSchema = z.object({
  supplierId: z.string(),
  warehouseId: z.string(),
  authorizationProfileId: z.string(),
  correctionDeliveryNoteNumber: z.string().nullish(),
  correctionDeliveryNoteDate: PastOrTodayDateSchema.nullish(),
  invoiceNumber: z.string().nullish(),
  invoiceIssueDate: PastOrTodayDateSchema.nullish(),
  paymentType: PaymentTypeSchema,
  currency: z.string(),
  exchangeRate: z.number().nullish(),
  ncConversion: z.string().nullish(),
  note: z.string().nullish(),
});

export type ReceiveNoteCorrectionForm = z.infer<typeof ReceiveNoteCorrectionFormSchema>;
